import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CallbackRefReducerState {
  token: string | null;
}

const initialState: CallbackRefReducerState = {
  token: null,
};

const callbackRefSlice = createSlice({
  name: "callbackRef",
  initialState,
  reducers: {
    setCallbackRef(state, action: PayloadAction<string | null>) {
      state.token = action.payload;
    },
  },
});

export const { setCallbackRef } = callbackRefSlice.actions;

export default callbackRefSlice.reducer;
